import { useEffect } from 'react';

import { Like } from '@depop/web-thrift-ui/Illustrations/Like';
import { useTranslations } from 'next-intl';

import { SignupGateModal } from '@/components/SignupGateModal';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { getGuestLikes } from '@/modules/guestLikes/helpers';

type Props = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
};

export function GuestLikesModal({ isOpen, setOpen }: Props) {
  const t = useTranslations('common');
  const { sendActivityTrackerEvent } = useActivityTracker();

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    sendActivityTrackerEvent(ActivityTrackerEventType.GUEST_LIKE_PROMPT_VIEW, {
      type: 'signup_block',
      schemaVersion: '1.0',
      likeCount: getGuestLikes().length,
    });
  }, [isOpen]);

  function handleSignupClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'guest_like_modal_signup_cta',
      schemaVersion: '1.0',
    });
  }

  function handleLoginClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'guest_like_modal_login_cta',
      schemaVersion: '1.0',
    });
  }

  function handleDismissClick() {
    sendActivityTrackerEvent(ActivityTrackerEventType.CTA_ACTION, {
      type: 'guest_like_modal_dismiss_cta',
      schemaVersion: '1.0',
    });
  }

  return (
    <SignupGateModal
      id="guest-likes-modal"
      isOpen={isOpen}
      setOpen={setOpen}
      title={t('GuestLikesModal.Title')}
      description={t('GuestLikesModal.Description')}
      illustration={<Like size="large" />}
      trackingId="guest-likes"
      redirectParam={encodeURIComponent('/[username]/likes/')}
      handleSignupClick={handleSignupClick}
      handleLoginClick={handleLoginClick}
      handleDismissClick={handleDismissClick}
    />
  );
}
